module.exports = __webpack_public_path__ + "static/img/cover2.86ffb50a.svg";